module.exports = __webpack_public_path__ + "media/images/flags/da-c2e570fa503242ab4c3edca6b2acb2cb.svg";